import {
  AssignmentWizardData, Contact, IdentityDocument, WizardContact,
} from '../../../../../providers/api/dtos';
import { isEmpty } from '../../../../../utils/object/object';
import type { AssignmentWizardPlanimetryDelegationFormModel } from './AssignmentWizardPlanimetryDelegationForm';

export const assignmentWizardDataToAssignmentWizardPlanimetryDelegationFormModel = (
  initialData: AssignmentWizardData,
  existingContacts: Contact[],
): AssignmentWizardPlanimetryDelegationFormModel | undefined => {
  let delegatedContact: WizardContact | undefined;
  if (initialData.contacts?.length === 1) {
    [delegatedContact] = initialData.contacts;
  } else if (initialData.contacts && initialData.contacts?.length > 1) {
    delegatedContact = initialData.contacts.find(({ planimetryDelegating }) => planimetryDelegating);
  }
  const existingDelegatedContact = existingContacts.find(({ id }) => id === delegatedContact?.id);

  return {
    contactId: delegatedContact?.id || '',
    planimetryDelegationRequired: initialData.planimetryDelegationRequired,
    identityDocumentType: delegatedContact?.overriddenFields?.identityDocument?.type || existingDelegatedContact?.identityDocument?.type || '',
    identityDocumentNumber: delegatedContact?.overriddenFields?.identityDocument?.number || existingDelegatedContact?.identityDocument?.number || '',
    identityDocumentIssuedBy: delegatedContact?.overriddenFields?.identityDocument?.issuedBy || existingDelegatedContact?.identityDocument?.issuedBy || '',
    identityDocumentIssuedAt: delegatedContact?.overriddenFields?.identityDocument?.issuedAt || existingDelegatedContact?.identityDocument?.issuedAt || '',
  };
};

export const contactToAssignmentWizardPlanimetryDelegationFormModel = (
  contact?: Contact,
): AssignmentWizardPlanimetryDelegationFormModel | undefined => {
  if (!contact) return undefined;

  return {
    contactId: contact?.id || '',
    planimetryDelegationRequired: true,
    identityDocumentType: contact?.identityDocument?.type || '',
    identityDocumentNumber: contact?.identityDocument?.number || '',
    identityDocumentIssuedBy: contact?.identityDocument?.issuedBy || '',
    identityDocumentIssuedAt: contact?.identityDocument?.issuedAt || '',
  };
};

export const assignmentWizardPlanimetryDelegationFormModelToIdentityDocument = (formValues: AssignmentWizardPlanimetryDelegationFormModel): IdentityDocument | undefined => {
  const identityDocument = {
    type: formValues.identityDocumentType ? formValues.identityDocumentType : undefined,
    number: formValues.identityDocumentNumber || undefined,
    issuedBy: formValues.identityDocumentIssuedBy || undefined,
    issuedAt: formValues.identityDocumentIssuedAt ? new Date(formValues.identityDocumentIssuedAt).toISOString() : undefined,
  };

  return isEmpty(identityDocument) ? undefined : identityDocument;
};

export const toAssignmentWizardData = (
  existingData: AssignmentWizardData,
  planimetryDelegationRequired: boolean,
  delegatedContact?: Contact,
): AssignmentWizardData => {
  existingData.contacts = existingData.contacts?.map((contact) => {
    if (planimetryDelegationRequired && contact.id === delegatedContact?.id) {
      return {
        ...contact,
        updatedAt: delegatedContact?.updatedAt,
        planimetryDelegating: true,
        overriddenFields: {
          ...contact.overriddenFields,
          identityDocument: delegatedContact?.identityDocument,
        },
      };
    }

    return {
      ...contact,
      planimetryDelegating: false,
    };
  });

  const newValues: AssignmentWizardData = {
    ...existingData,
    isDigitallySigned: false,
    planimetryDelegationRequired,
  };

  return newValues;
};
